import { atom } from "jotai";

export const deleteCropBoxAtom = atom<any | null>(null);